import React, { useState } from "react";
import { TableCell, TableRow, Button } from "@mui/material";
import PrescriptionPopup from "./PrescriptionPopup";
import dele from "../../../../assets/DigitalMarketing/image/delete.svg";
import eye from "../../../../assets/DigitalMarketing/image/visibility.svg";
import { styled } from "@mui/material/styles";

interface Medicine {
  sNo: number;
  name: string;
  strength: string;
  dosage: string;
  intake: string;
  duration: string;
}

interface PatientData {
  sNo: number;
  patientName: string;
  test: string;
  dateTime: string;
  pulseRate: number;
  bloodPressure: string;
  complaints: string;
  tests: string[];
  consultantName: string;
  hne: string;
  medicines: Medicine[];
  advice: string;
}

const StyledButton = styled(Button)({
  backgroundColor: "#E0F7FF",
  color: "#007FFF",
  borderRadius: "20px",
  padding: "5px 15px",
  fontSize: "0.875rem",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#B3E5FF",
  },
});

const dummyData: PatientData[] = [
  {
    sNo: 1,
    patientName: "John Doe",
    test: "Hemoglobin test",
    dateTime: "21 FEB 2023 | 08:24 AM",
    pulseRate: 77,
    bloodPressure: "122/70",
    complaints: "Fatigue, dizziness",
    tests: ["Hemoglobin test", "Complete blood count"],
    consultantName: "Dr. Smith",
    hne: "Sample H&E description text here.",
    medicines: [
      { sNo: 1, name: "Medicine A", strength: "10 mg", dosage: "1-1-0", intake: "After Food", duration: "10 days" },
      { sNo: 2, name: "Medicine B", strength: "5 mg", dosage: "0-0-1", intake: "Before Food", duration: "7 days" },
    ],
    advice: "Follow up in 1 week and avoid strenuous activities.",
  },
  {
    sNo: 2,
    patientName: "John Doe",
    test: "Hemoglobin test",
    dateTime: "21 FEB 2023 | 08:24 AM",
    pulseRate: 77,
    bloodPressure: "122/70",
    complaints: "Fatigue, dizziness",
    tests: ["Hemoglobin test", "Complete blood count"],
    consultantName: "Dr. Smith",
    hne: "Sample H&E description text here.",
    medicines: [
      { sNo: 1, name: "Medicine A", strength: "10 mg", dosage: "1-1-0", intake: "After Food", duration: "10 days" },
      { sNo: 2, name: "Medicine B", strength: "5 mg", dosage: "0-0-1", intake: "Before Food", duration: "7 days" },
    ],
    advice: "Follow up in 1 week and avoid strenuous activities.",
  },
  
  {
    sNo: 3,
    patientName: "John Doe",
    test: "Hemoglobin test",
    dateTime: "21 FEB 2023 | 08:24 AM",
    pulseRate: 77,
    bloodPressure: "122/70",
    complaints: "Fatigue, dizziness",
    tests: ["Hemoglobin test", "Complete blood count"],
    consultantName: "Dr. Smith",
    hne: "Sample H&E description text here.",
    medicines: [
      { sNo: 1, name: "Medicine A", strength: "10 mg", dosage: "1-1-0", intake: "After Food", duration: "10 days" },
      { sNo: 2, name: "Medicine B", strength: "5 mg", dosage: "0-0-1", intake: "Before Food", duration: "7 days" },
    ],
    advice: "Follow up in 1 week and avoid strenuous activities.",
  },
  
  
];

const TableLists: React.FC<{ searchValue: string }> = ({ searchValue }) => {
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState<PatientData | null>(null);

  const handleOpen = (data: PatientData) => {
    setSelectedData(data);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const filteredData = dummyData.filter((row) =>
    row.patientName.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>
      {filteredData.map((row) => (
        <TableRow key={row.sNo}>
          <TableCell align="left">{row.sNo}</TableCell>
          <TableCell align="left">{row.patientName}</TableCell>
          <TableCell align="left">{row.test}</TableCell>
          <TableCell align="left">{row.dateTime}</TableCell>
          <TableCell align="left">
            <StyledButton variant="contained" size="small">
              Assign to Lab
            </StyledButton>
          </TableCell>
          <TableCell align="left">
            <img
              src={eye}
              alt="view"
              className="blue-c action-icon cursor"
              onClick={() => handleOpen(row)}
            />
            &nbsp;&nbsp;&nbsp;
            <img
              src={dele}
              alt="delete"
              className="delete-icon cursor action-icon"
            />
          </TableCell>
        </TableRow>
      ))}
      {selectedData && (
        <PrescriptionPopup
          open={open}
          handleClose={handleClose}
          data={selectedData}
        />
      )}
    </>
  );
};

export default TableLists;
